import { Paper } from "@mui/material";
import PlanHeaderWithoutPlanCode from "../../../../../shared/enrollment/planHeaderWithoutPlanCode/PlanHeaderWithoutPlanCode";
import CircleIcon from "@mui/icons-material/Circle";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import LinkIcon from "@mui/icons-material/Link";
import { useContext } from "react";
import { ThemeContext } from "../../../../../../contexts";
import FormSingleAction from "../../../../../shared/enrollment/formSingleAction/FormSingleAction";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import { useHistory } from "react-router-dom";

import "./gltdForm.css";
import { PlanFormProps } from "../../../../../../types/components/enrollmentProps.types";

const GltdForm = ({}: PlanFormProps): JSX.Element => {
	const history = useHistory();
	const { theme } = useContext(ThemeContext);
	return (
		<div className="GLTD-classes theme-container">
			<Paper className="paper-container">
				<PlanHeaderWithoutPlanCode planName="Group Long Term Disability" />
				<div className="theme-plan-section-margin" />
				<div className="theme-plan-icon-item-center-container">
					<div>
						<ClearAllIcon className="theme-plan-point-header-icon" style={{ color: theme.primary_color }} />
					</div>
					<div className="theme-plan-point-header-text">Class One</div>
				</div>
				<div className="theme-plan-sub-inner-section-margin" />
				<div style={{ marginLeft: "20px" }}>
					<div className="theme-plan-description-text">
						Long Term Disability (LTD) Plan offers you security of earnings (upon approval from Lincoln
						Financial Group) should you become disabled.
					</div>
					<div className="theme-plan-sub-inner-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							The LTD benefit is a company-paid benefit for all designated full-time employees; there is
							no cost to the insured.
						</div>
					</div>
					<br></br>
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">Elimination period: 180 days.</div>
					</div>
					<br></br>
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							The benefit pays the insured 50% of base pay to age 65, or until no longer disabled.
						</div>
					</div>
					<div className="sub-point-section">
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">Maximum Disability Benefit $1,500/mo</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">Minimum Disability Benefit $100/mo</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">
								Claims are processed for approval and paid by Lincoln Financial Group (if approved)
							</div>
						</div>
					</div>
				</div>
				<div className="theme-plan-section-margin" />
				<FormSingleAction
					buttonCallback={() => {
						history.push("/enrollment?step=4");
					}}
					buttonText="To Submit Class One"
				/>
				<div className="theme-plan-section-margin" />
				<div className="theme-plan-icon-item-center-container">
					<div>
						<ClearAllIcon className="theme-plan-point-header-icon" style={{ color: theme.primary_color }} />
					</div>
					<div className="theme-plan-point-header-text">
						Class Two (Employee Who Has Buyup Eligibility - Store Director, Pharmacist or Monthly Salaried)
					</div>
				</div>
				<div className="theme-plan-sub-inner-section-margin" />
				<div style={{ marginLeft: "20px" }}>
					<div className="theme-plan-description-text">
						The Class 2 benefit is available to those classified as Store Directors, Monthly Salaried
						Employees, or Pharmacists.
					</div>
					<div className="theme-plan-sub-inner-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							Cost: The participant is responsible for the benefit premium. The premium is 338% of weekly
							or monthly salary. This amount will be deducted from your paycheck on an after-tax basis
						</div>
					</div>
					<div className="sub-point-section">
						<div className="theme-plan-icon-item-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">Elimination period: 180 days </div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">
								Pays you 60% of your base pay to age 65, or until no longer disabled
							</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">Maximum Disability Benefit $15,000/mo</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">Minimum Disability Benefit $100/mo</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">
								Definition: 24 month own occupation, then any occupation to age 65
							</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">
								If an eligible participant does NOT enroll in the &quot;buy-up&quot; LTD option, their
								benefits default to the benefits listed in the Class 1 coverage.
							</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<CircleIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">
								Claims are processed for approval and paid by Lincoln Financial Group (if approved)
							</div>
						</div>
					</div>

					<div className="theme-plan-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-text">
							<strong>Note:</strong> As a designated full-time employee, you are automatically covered
							under the default LTD (Long Term Disability) Plan, which is a company-paid benefit. This
							benefit replaces 50% of your income, with a maximum of $1.5000 per month. HOWEVER, as a
							Store Director, Pharmacist, or Monthly Salaried employee, you are eligible to participate in
							the Group LTD (Long Term Disability) Buy-Up Plan. This benefit replaces 60% of your income,
							with a maximum of $15.000 per month. Because you would contribute to the cost of this
							coverage, your disability benefits would not be subject to taxes. The current cost of
							coverage is $.00338 x your weekly or monthly salary, this amount would be conveniently
							deducted from your paycheck each pay period.
						</div>
					</div>
					<div className="theme-plan-section-margin" />
					<div className="external-links">
						<div>
							<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="header">
							To Know More About The Benefits Offered, <a href="#">Click Here</a>
						</div>
					</div>
				</div>
				<div className="theme-plan-section-margin" />
				<FormSingleAction
					buttonCallback={() => {
						history.push("/enrollment?step=6");
					}}
					buttonText="To Submit Class Two"
				/>
			</Paper>
		</div>
	);
};

export default GltdForm;
